export default "__VITE_ASSET__DKMH_9rA__"